import React from "react";
import { LoadingAnimation, Flex, Box } from "@nulogy/components";
import styled from "styled-components";

const Overlay = styled(Flex)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  justifycontent: center;
  alignitems: center;
`;

const Loading = () => (
  <Overlay>
    <Flex flexGrow="2" flexDirection="column" margin="auto" mb="x4">
      <Box mb="x1" style={{ textAlign: "center" }}>
        <LoadingAnimation />
      </Box>
    </Flex>
  </Overlay>
);

export default Loading;
